import * as action_types from '../actions/actionTypes'

const initialState = {
  data: []
};

export default function breadcrumbsUpdate(state = initialState, { type, payload }) {
  switch (type) {
    case action_types.UPDATE_BREADCRUMBS:
      return { data: payload };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/breadcrumbs.js